import React from "react";
import { ParsersPanel } from "../../api/ParsersPanel";
import { useArabicSources } from "./hooks/useArabicSources";
import SourcesTab from "./SourcesTab";

const fetchArabicTimeseries = async (
  token: string,
  sourceLink: string,
  days: number,
) => (await ParsersPanel.getArabicTimeseries(token, sourceLink, days)).series;

const ArabicSourcesTab: React.FC = () => {
  const { rows, loading, error } = useArabicSources(7);

  return (
    <SourcesTab
      rows={rows}
      loading={loading}
      error={error}
      node="arabic"
      sourceColumnLabel="Source"
      fetchTimeseries={fetchArabicTimeseries}
    />
  );
};

export default ArabicSourcesTab;
